


















import CommonBase from "../CommonBase";
import {Component, Inject, Prop, Watch} from "vue-property-decorator";
import Api from "./Api";
import {Company} from "../../modules/models";
import {Debouncer} from "../../modules/utils";

@Component
export default class CompanySelector extends CommonBase {
    @Inject()
    api!: Api;

    @Prop({default: null})
    value!: Company | null;
    @Prop({default: "Firma"})
    label!: string;
    @Prop({default: false})
    persistentHint!: boolean;

    loading: boolean | string = false;
    items: Company[] = [];
    search: string | null = null;
    errorMessages: string[] = [];

    get selected() {
        return this.value;
    }
    set selected(s: Company | null) {
        const selectedOrgnum = s != null ? s.orgNum : null;
        const existingOrgnum = this.value != null ? this.value.orgNum : null;
        if(selectedOrgnum != existingOrgnum) {

            this.$emit("input", s);
        }
    }

    // Check if given company is in items array
    isInItems(c: Company): boolean {
        return this.items.some((r) => r.orgNum === c.orgNum);
    }

    @Watch("value", {immediate: true})
    onValueChange(s: Company | null) {
        if(s != null && !this.isInItems(s)) { // value set externally without search, is therefore not in items. Must be added to be displayed correct
            this.items.push(s);
        }
    }

   @Watch("search")
    onSearch(newSearch: string, oldSearch: string) {
        if(newSearch && newSearch.length >= 2) {
            this.serverSearch(newSearch);
        }
    }

    check() {
        if(this.items.length == 0 && this.search != null && this.search.length >= 2) {
            this.errorMessages = [`Firma ikke funnet, juster søketekst`];
        } else {
            this.errorMessages = [];
        }
    }

    searchDebouncer = new Debouncer(300);

    async serverSearch(newSearch: string) {
        if(newSearch) {
            this.loading = "secondary";
            if(await this.searchDebouncer.debounce()) {
                try {
                    this.items = await this.api.brregSearch(newSearch);
                    this.check();
                } catch (err) {
                    this.emitError(err);
                } finally {
                    this.loading = false;
                }
            }
        }
    }
}
